declare const gsap: any;
declare const ScrollTrigger: any;
declare const SplitText: any;
declare const $: JQueryStatic;
declare const _options: any;

import { app, debug } from '../app';
import '../plugins/gsap.min.js';
import '../plugins/ScrollTrigger.min.js';
import '../plugins/SplitText.min.js';

export class Animations {
    constructor() {
        gsap.registerPlugin(ScrollTrigger);
    }

    public initAnimations():void {
        document.querySelector('body.-home') && this.homeAnimation();
    }

    private homeAnimation():void {
        // let splitText = new window.SplitText(target, {type: "lines,chars", linesClass: 'line'});
        let tl1 = gsap.timeline();
        let target: HTMLElement = document.querySelector('.section-main h1');
        let targetParagraphs: NodeListOf<HTMLParagraphElement> = target.querySelectorAll('p');
        const width = window.innerWidth;

        targetParagraphs.forEach((para: HTMLParagraphElement) => {
            let paraString: string = para.innerText;
            para.innerHTML = '';

            for(let i: number = 0; i < paraString.length; i++) {
                let char: string = paraString.charAt(i);

                const span: HTMLSpanElement = document.createElement('span');
                span.innerText = char;
                span.style.display = 'block';
                para.appendChild(span);
            }
        });
        tl1.to(".section-main h1", {opacity: 1, duration: 0.3, delay: 0.3, ease: 'power2.out'});
        tl1.from(".section-main h1 p span",
            {y: '100%', x: '20%', duration: 1, stagger: 0.025, ease: 'Power3.easeInOut'},"<"
        );
        tl1.to(".section-main img",
            {opacity: 1, x: 0, duration: 0.3, stagger: 0.25, ease: 'power2.out', onComplete: () => {
                // tymczasowo 500px bo jest problem z importem breakpointow z tailwinda
                if (width > 500) {
                    setTimeout(() => {
                            this.mouseFollowAnimation('.section-main .mouse-follow', 1000);
                    }, 100);
                }
            }},
        );
        tl1.play();
    }

    private mouseFollowAnimation(selector: string, distance: number): void {
        interface Settings {
            selector: string;
            distance: number;
        }

        interface Position {
            x: number;
            y: number;
        }

        const settings: Settings = {
            selector: selector,
            distance: distance
        };

        let mousePosition: Position = {
            x: 0,
            y: 0
        };

        let animationFrameId: number;
        let isMoving: boolean = false;

        const getElementCenter = (element: HTMLElement): Position => {
            const rect = element.getBoundingClientRect();
            const halfWidth = rect.width / 2;
            const halfHeight = rect.height / 2;
            
            return {
                x: rect.left + window.scrollX + halfWidth,
                y: rect.top + window.scrollY + halfHeight
            };
        };

        const updateElements = (): void => {
            const elements = document.querySelectorAll<HTMLElement>(settings.selector);

            elements.forEach((element: HTMLElement) => {
                const customDistance = element.dataset.elasticDistance;
                const effectiveDistance = customDistance 
                    ? parseInt(customDistance, 10) 
                    : settings.distance;

                const center = getElementCenter(element);
                const elementDistance: Position = {
                    x: center.x - mousePosition.x,
                    y: center.y - mousePosition.y
                };

                const dist = Math.sqrt(
                    elementDistance.x * elementDistance.x + 
                    elementDistance.y * elementDistance.y
                );

                if (dist < effectiveDistance) {
                    const distanceFactor = 1 - (dist / effectiveDistance);
                    
                    gsap.to(element, {
                        duration: 2,
                        x: -Math.round(elementDistance.x * 0.3 * distanceFactor),
                        y: -Math.round(elementDistance.y * 0.3 * distanceFactor),
                        ease: "power2.out"
                    });
                } else {
                    gsap.to(element, {
                        duration: 1.5,
                        x: 0,
                        y: 0,
                        ease: "power1.out"
                    });
                }
            });

            if (isMoving) {
                animationFrameId = requestAnimationFrame(updateElements);
            }
        };

        const handleMouseMove = (e: MouseEvent): void => {
            mousePosition = {
                x: e.pageX,
                y: e.pageY
            };

            if (!isMoving) {
                isMoving = true;
                animationFrameId = requestAnimationFrame(updateElements);
            }
        };

        const handleMouseLeave = (): void => {
            isMoving = false;
            if (animationFrameId) {
                cancelAnimationFrame(animationFrameId);
            }

            const elements = document.querySelectorAll<HTMLElement>(settings.selector);
            elements.forEach((element: HTMLElement) => {
                gsap.to(element, {
                    duration: 1.5,
                    x: 0,
                    y: 0,
                    ease: "power1.out"
                });
            });
        };

        document.addEventListener('mousemove', handleMouseMove);
        document.addEventListener('mouseleave', handleMouseLeave);
    }
}